/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Last_Sign_In_NeverInputs */

const fr_account_audit_last_sign_in_never = /** @type {(inputs: Account_Audit_Last_Sign_In_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne s'est jamais connecté`)
};

/**

* @param {Account_Audit_Last_Sign_In_NeverInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_last_sign_in_never = /** @type {((inputs?: Account_Audit_Last_Sign_In_NeverInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Last_Sign_In_NeverInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_last_sign_in_never(inputs)
});